<template>
  <article class="exam-prereqs" :class="`exam-prereqs--${normalizedMode}`">
    <div class="exam-prereqs__top">
      <p class="exam-prereqs__eyebrow">{{ content.eyebrow }}</p>
      <span class="exam-prereqs__badge">{{ content.badge }}</span>
    </div>

    <div class="exam-prereqs__copy">
      <h3>{{ content.title }}</h3>

      <ul class="exam-prereqs__list">
        <li v-for="item in content.items" :key="item">
          {{ item }}
        </li>
      </ul>

      <p class="exam-prereqs__footer">
        {{ content.footer }}
      </p>
    </div>
  </article>
</template>

<script>
const cardContent = {
  taxi: {
    eyebrow: "Avant inscription",
    badge: "Taxi",
    title: "Prérequis d'inscription à l'examen taxi",
    items: [
      "Le candidat doit être détenteur d'une carte d'identité européenne valide ou avoir un titre de séjour lui permettant d'exercer en France.",
      "Le candidat doit être titulaire d'un permis B depuis au moins trois ans et non soumis à une période probatoire.",
    ],
    footer: "Durée d'accès à la formation: 11 Jours minimum.",
  },
  vtc: {
    eyebrow: "Avant inscription",
    badge: "VTC",
    title: "Prérequis d'inscription à l'examen VTC",
    items: [
      "Le candidat doit être détenteur d'une carte d'identité européenne valide ou avoir un titre de séjour lui permettant d'exercer en France.",
      "Le candidat doit être titulaire d'un permis B depuis au moins trois ans et non soumis à une période probatoire.",
      "Le casier judiciaire, la visite médicale VTC et le PSC1 VTC ne sont pas demandés lors de l'inscription à l'examen VTC.",
    ],
    footer: "Durée d'accès à la formation: 11 Jours minimum.",
  },
  mix: {
    eyebrow: "Avant inscription",
    badge: "Taxi / VTC",
    title: "Prérequis d'inscription à l'examen taxi / VTC",
    items: [
      "Le candidat doit être détenteur d'une carte d'identité européenne valide ou avoir un titre de séjour lui permettant d'exercer en France.",
      "Le candidat doit être titulaire d'un permis B depuis au moins trois ans et non soumis à une période probatoire.",
      "Le casier judiciaire, la visite médicale VTC et le PSC1 VTC ne sont pas demandés lors de l'inscription à l'examen VTC.",
    ],
    footer: "Durée d'accès à la formation: 11 Jours minimum.",
  },
};

export default {
  name: "ExamPrerequisitesCard",
  props: {
    mode: {
      type: String,
      default: "taxi",
    },
  },
  computed: {
    normalizedMode() {
      return ["taxi", "vtc", "mix"].includes(this.mode) ? this.mode : "taxi";
    },
    content() {
      return cardContent[this.normalizedMode];
    },
  },
};
</script>

<style lang="scss" scoped>
.exam-prereqs {
  padding: clamp(22px, 4vw, 30px);
  border-radius: 28px;
  background: $color-primary;
  box-shadow: 0 18px 34px rgba(0, 42, 84, 0.18);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.exam-prereqs__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.exam-prereqs__eyebrow,
.exam-prereqs__badge {
  margin: 0;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "adam";
  font-size: 0.68rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.exam-prereqs__eyebrow {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(245, 236, 236, 0.88);
}

.exam-prereqs__badge {
  background: $color-secondary;
  color: $color-primary;
  box-shadow: 0 8px 14px rgba(254, 185, 20, 0.18);
}

.exam-prereqs__copy {
  display: grid;
  gap: 18px;

  h3 {
    margin: 0;
    color: $color-text-light;
    font-size: clamp(1.32rem, 1.05rem + 0.35vw, 1.75rem);
    line-height: 1.12;
  }
}

.exam-prereqs__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;

  li {
    position: relative;
    padding-left: 18px;
    color: rgba(245, 236, 236, 0.92);
    line-height: 1.6;

    &::before {
      content: "";
      position: absolute;
      top: 0.72rem;
      left: 0;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $color-secondary;
      box-shadow: 0 0 0 4px rgba(254, 185, 20, 0.14);
    }
  }
}

.exam-prereqs__footer {
  margin: 0;
  padding: 14px 16px;
  border-radius: 18px;
  background: rgba(0, 0, 0, 0.22);
  color: $color-secondary;
  font-family: "adam";
  font-size: 0.7rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.exam-prereqs--mix {
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(
      90deg,
      $color-primary 0%,
      $color-primary 45%,
      $color-secondary 45%,
      $color-secondary 100%
    );
  }
}

@media screen and (max-width: 767px) {
  .exam-prereqs {
    border-radius: 24px;
  }

  .exam-prereqs__top {
    align-items: flex-start;
    flex-direction: column;
  }
}
</style>
